<template>
  <div>
    <el-table :data="userList" height="calc(100vh - 360px)">
      <el-table-column prop="id" label="奖券ID" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="tenantId" label="商户ID" align="left">
        <template slot-scope="scope">
          <span>{{ scope.row.tenantId }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="name" label="奖券名称 " width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="奖券内容"
        align="center"
        width="180"
      >
        <template slot-scope="scope">
          {{ FINDPAYMENTS(scope.row.content) }}
        </template>
      </el-table-column>

      <el-table-column prop="faceValue" label="奖券面值" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.faceValue }}</span>
        </template>
      </el-table-column>

      <el-table-column label="奖券池总张数" width="180">
        <template slot-scope="scope">{{ scope.row.totalSize }}</template>
      </el-table-column>
      <el-table-column label="奖券池当前剩余" width="180">
        <template slot-scope="scope">{{ scope.row.remainSize }}</template>
      </el-table-column>

      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">关闭 </span>
          <span v-if="scope.row.status === 1">激活</span>
        </template>
      </el-table-column>

      <el-table-column
        label="修改时间"
        align="center"
        prop="updatedTime"
        width="180"
      >
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>

      <!-- <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="handleUpdate(scope.row)"
            >修改</el-button
          > -->
      <!-- <el-button
            size="mini"
            type="text"
            @click="handleUpdatePartner(scope.row, 0)"
            >关闭</el-button
          > -->
      -->
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>

    <!-- 修改dialog -->
    <el-dialog
      title="修改奖券"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div class="content">
            <el-form :model="updateForm" :rules="rules" ref="form">
              <el-form-item label="奖券名称" prop="name">
                <el-input
                  v-model="updateForm.name"
                  class="searchIpt"
                  autocomplete="off"
                  placeholder="请输入奖券名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="奖券内容" prop="content">
                <el-select
                  v-model="updateForm.content"
                  placeholder="奖券内容"
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in PAYMENTS"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="奖券面值" prop="faceValue">
                <el-input
                  v-model="updateForm.faceValue"
                  class="searchIpt"
                  autocomplete="off"
                  placeholder="输入面值"
                >
                  <template slot="append">USDT</template>
                </el-input>
              </el-form-item>
              <el-form-item label="奖池" prop="totalSize">
                <!-- <span>当前剩余 {{ remaining }}</span> -->
                <el-input
                  v-model="updateForm.totalSize"
                  class="searchIpt"
                  autocomplete="off"
                  placeholder="输入张数"
                >
                </el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button size="mini" type="primary" @click="add">保 存</el-button>
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <!-- 升级合伙人 -->
    <el-dialog
      :title="title"
      :visible.sync="partnerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card box-card1">
          <div class="content">
            <el-form label-width="50px">
              <el-form-item label="比例 :">
                <el-input
                  type="number"
                  placeholder="请输入返佣比例"
                  v-model="input2"
                >
                  <template slot="append">%</template>
                </el-input>
                <div class="tip">
                  <span>
                    <i class="el-icon-warning-outline"></i>
                    说明:返佣比例一旦设定,只支持提高,不支持降低
                  </span>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button size="mini" @click="partnerDialogVisible = false"
              >取 消</el-button
            >
            <el-button size="mini" type="primary" @click="addRate"
              >确 定</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import { FINDPAYMENTS } from '../../constants'
import { PAYMENTS } from '../../constants'

export default {
  name: 'list',
  data() {
    return {
      PAYMENTS,
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      textarea2: '',
      centerDialogVisible: false,
      partnerDialogVisible: false,
      input2: '',
      upgradeRateForm: {},
      title: '',
      rules: {
        name: [{ required: true, message: '请输入奖券名称', trigger: 'blur' }],
        content: [
          { required: true, message: '请输入奖券内容', trigger: 'blur' },
        ],
        faceValue: [
          { required: true, message: '请输入奖券面值', trigger: 'blur' },
        ],
        totalSize: [{ required: true, message: '请输入奖池', trigger: 'blur' }],
      },
    }
  },
  components: {
    Pagination,
  },
  methods: {
    ...mapActions('user', ['addRemark']),
    ...mapActions('activityLottery', [
      'upgradePartner',
      'upgradeRate',
      'updLottery',
    ]),
    ...mapMutations('activityLottery', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
      'setPagination',
    ]),
    FINDPAYMENTS,
    add() {
      this.updLottery({
        content: this.updateForm.content,
        name: this.updateForm.name,
        totalSize: this.updateForm.totalSize,
        faceValue: this.updateForm.faceValue,
        id: this.updateForm.id,
        tenantId: -1,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.updateForm = {}), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
        if (res.code == 1) {
          this.$message.error(res.error.msg)
        }
      })
    },
    addRate() {
      if (this.btnType == 0) {
        this.upgradePartner({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('申请合伙人成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
      if (this.btnType == 1) {
        this.upgradeRate({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('设置返佣比例成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row) {
      this.updateForm = { ...row }
      this.centerDialogVisible = true
    },
    handleUpdatePartner(row, type) {
      this.title = '升级合伙人'
      this.upgradeRateForm = { ...row }
      this.partnerDialogVisible = true
      this.btnType = type
    },
    handleRate(row, type) {
      this.title = '设置返佣比例'
      this.partnerDialogVisible = true
      this.upgradeRateForm = { ...row }
      this.input2 = row.rebateRate * 100
      this.btnType = type
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('activityLottery', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
}
</script>

<style lang="less" src="../../../../styles/table.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
.cc {
  color: #97a0ff;
  font-weight: bold;
}
::v-deep .el-dialog__title {
  color: #6767b3;
  font-size: 24px;
}
::v-deep.el-dialog__headerbtn {
  font-size: 26px;
}

::v-deep .el-dialog--center {
  margin-top: 5vh;
  width: 468px;
  // height: 557px;
  background: #f5f6ff;
  border-radius: 8px;
}
::v-deep.el-table th {
  font-weight: bold;
  color: #909399;
}
</style>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  display: flex;
  justify-content: center;
  .main {
    width: 100%;
    position: relative;
    height: 100%;
    .box-card {
      width: 100%;
      height: 100% !important;
      .el-card__body {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .el-textarea {
          box-shadow:
            0px 0px 1px rgba(24, 26, 32, 0.1),
            0px 3px 6px rgba(71, 77, 87, 0.04),
            0px 1px 2px rgba(24, 26, 32, 0.04);
        }
        .el-textarea__inner {
          padding: 18px 16px;
        }
        .btn {
          display: flex;
          justify-content: center;
          .el-button--primary {
            width: 156px;
            height: 37px;
            background: #707aff;
            border-radius: 4px;
          }
          .el-button--default {
            width: 156px;
            height: 37px;
            background-color: #f5f6f9;
          }
        }
      }
    }
    .box-card1 {
      height: 170px;
      .btn {
        padding-bottom: 10px;
      }
      .tip {
        text-align: center;
        color: #707aff;
      }
    }
  }
}
</style>
